import React from 'react';
import './Commodities.css';

// Import all images
import imgGrains from '../../assets/grains.jpg';
import imgSpices from '../../assets/spices.jpg';
import imgSugar from '../../assets/sugar.jpg';
import imgPulses from '../../assets/pulses.jpg';
import imgVeg from '../../assets/vegetables.jpg'; // Make sure to add this image
import imgOil from '../../assets/oilseeds.jpg';   // Make sure to add this image

const Commodities = () => {
  const commodities = [
    {
      id: 1,
      title: "Grains",
      desc: "Comprehensive price assessments and market insights for major global grain markets including wheat, corn, and barley.",
      image: imgGrains,
      theme: "white" // The highlight card
    },
    {
      id: 4,
      title: "Pulses",
      desc: "Expert commentary and data-driven insights into the pulses sector, supporting trade efficiency across international borders.",
      image: imgPulses,
      theme: "white"
    },
    {
      id: 6,
      title: "Oilseeds",
      desc: "Global insights into the complex oilseeds market, covering soybeans, rapeseed, and derivatives to support crushing and trading decisions.",
      image: imgOil,
      theme: "white"
    },
    {
      id: 3,
      title: "Sugar",
      desc: "In-depth analysis and forecasting for the global sugar trade, covering raw and white sugar futures and physical markets.",
      image: imgSugar,
      theme: "white"
    },
    {
      id: 5,
      title: "Vegetables",
      desc: "Real-time pricing and market analysis for fresh produce markets, helping stakeholders navigate the volatility of perishable supply chains.",
      image: imgVeg,
      theme: "white"
    },
    {
      id: 2,
      title: "Spices",
      desc: "Reliable benchmarking for the diverse global spice trade, offering transparency in naturally opaque markets.",
      image: imgSpices,
      theme: "white"
    }, 
  ];

  return (
    <section id="commodities-section" className="commodities-section container">
      <div className="section-header">
        <h2>Commodities we cover</h2>

        
      </div>

      <div className="commodities-grid">
        {commodities.map((item) => (
          <div key={item.id} className={`commodity-card ${item.theme}`}>
            <div className="card-image" style={{ backgroundImage: `url(${item.image})` }}></div>
            <div className="card-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Commodities;